import { render, staticRenderFns } from "./InterviewCoach.vue?vue&type=template&id=2676d5c6&scoped=true"
import script from "./InterviewCoach.vue?vue&type=script&lang=js"
export * from "./InterviewCoach.vue?vue&type=script&lang=js"
import style0 from "./InterviewCoach.vue?vue&type=style&index=0&id=2676d5c6&prod&scoped=true&lang=css"
import style1 from "../../css/newProjectDetail.css?vue&type=style&index=1&id=2676d5c6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2676d5c6",
  null
  
)

export default component.exports